import FilterSelectBlock from './FilterSelectBlock.vue';

export default FilterSelectBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterselect/index.ts